'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnackBarContainer = exports.snackBarBuilder = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _SnackBar = require('../../Presentational components/SnackBars/SnackBar/SnackBar');

var _SnackBar2 = _interopRequireDefault(_SnackBar);

var _actions = require('./actions');

var Actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var snackBarBuilder = exports.snackBarBuilder = function snackBarBuilder(mapStateToProps) {
  return (0, _reactRedux.connect)(mapStateToProps, Actions)(_SnackBar2.default);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    message: state.framework.snackBar.message,
    show: state.framework.snackBar.show,
    initiallyOpen: false
  };
};

var SnackBarContainer = exports.SnackBarContainer = snackBarBuilder(mapStateToProps);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/SnackBarContainer/SnackBarContainer.js
 ** module id = 477
 ** module chunks = 0
 **/